import { render, staticRenderFns } from "./ProjectVisaEdit.vue?vue&type=template&id=3a51e8a4&"
import script from "./ProjectVisaEdit.vue?vue&type=script&lang=js&"
export * from "./ProjectVisaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports